import React, { useState } from 'react'
import { Container, Nav, Navbar, NavDropdown} from 'react-bootstrap'
import { Link } from 'gatsby'

import * as styles from './Navbar.module.scss'

function HoverControlledDropdown(props) {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <NavDropdown
            {...props}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            show={isHovered}
        />
    );
}

export default function NavBar({ menuItems, location }) {
  const pathname = location.pathname
  return (
    <Container className={styles.navbar}>
        <Container>
        <Navbar expand="lg">
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
                <Nav.Link as={Link} className={pathname === '/' ? styles.navItemActive : styles.navItem} to="/">Introduction</Nav.Link>

                <Nav.Link as={Link} className={pathname === '/artist-biography' ? styles.navItemActive : styles.navItem} to="/artist-biography">
                    Artist Biography
                </Nav.Link>

                <Nav.Link as={Link} className={pathname === '/map' ? styles.navItemActive : styles.navItem} to="/map">
                    Map
                </Nav.Link>

                <Nav.Link as={Link} className={pathname === '/gallery' ? styles.navItemActive : styles.navItem} to="/gallery">
                    Gallery
                </Nav.Link>

                <HoverControlledDropdown className={styles.navItem} title="Index">
                    <NavDropdown.Item as={Link} to="/data-index">Overview</NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/data-index/chinese-temples">Chinese Temples 华人庙宇</NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/data-index/churches">Churches 天主教教堂</NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/data-index/hindu-temples">Hindu Temples 印度庙宇</NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/data-index/islamic-mosques">Islamic Mosques 回教堂</NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/data-index/sikh-temples">Sikh Temples 锡克庙宇</NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/data-index/other-temples">Other Temples 其它</NavDropdown.Item>
                </HoverControlledDropdown>

            </Nav>

            </Navbar.Collapse>

        </Navbar>
        </Container>
    </Container>

  )
}

